import type { VendorRequest } from './BeachBumzDashboard';
import type { CatalogRequest } from './SupplierCatalog';
import type { TeamApi } from './teamRequest';

export const PREVIEW_MESSAGE = 'Preview is read-only. Return to Admin View to make changes.';
function readOnly(body?: Record<string, unknown>) { if (body) throw new Error(PREVIEW_MESSAGE); }
export function partnerOrders(request: VendorRequest): VendorRequest {
  return async body => { readOnly(body); return { ...await request(), canRelease: false }; };
}
export function partnerCatalog(request: CatalogRequest): CatalogRequest {
  return async body => { readOnly(body); return { ...await request(), owner: false, funnelPhotos: {} }; };
}
export function previewTeam(request: TeamApi, role: string, email = ''): TeamApi {
  return async (body, query) => {
    readOnly(body);
    return request(undefined, { ...query, viewRole: role, viewEmail: email });
  };
}
